import type { HyloServices } from '@/model';
import { createFakeServices } from '@/testing/fake-services';
import { createRealServices } from './real-services';

export function createHyloServices(options: { baseUrl?: string; fake?: boolean } = {}): HyloServices {
  if (import.meta.env.DEV && (options.fake || import.meta.env.VITE_HYLO_FAKE === '1')) return createFakeServices();
  return createRealServices(options);
}
